import React, { createContext } from "react";

const GroupContext = createContext({});

export const GroupProvider = ({ children, data }) => {
  return <GroupContext.Provider value={data}>{children}</GroupContext.Provider>;
};

export default GroupContext;
